import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { DeepPartial } from '@df/util/type/deep-partial';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { PIO_OPTIONS } from './config/pio-options';
import { IPioOptions } from './core/interfaces';
import { PioRecommendService } from './core/pio-recommend.service';
import { PioTrackingService } from './core/pio-tracking.service';
import { ListingSortPioEngine } from './listing/listing-sort-pio-engine';
import { PioEngine } from './related-products/pio-engine';

export function providePio(config?: DeepPartial<IPioOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        PioRecommendService,
        {
            provide: PIO_OPTIONS,
            useFactory: () => {
                return defaultsDeep(config || {}, {
                    enabled: false,
                    listing: {
                        enabled: false,
                        devOnly: false,
                        ifExperiment: false,
                        user: false
                    },
                    user: {
                        enabled: false,
                        ifExperiment: false,
                        cookieSeries: 0
                    }
                });
            }
        },
        provideAppInitializer(() => {
            inject(PioTrackingService).appInitialize();

            surviveTreeShaking(PioEngine, ListingSortPioEngine);
        })
    ]);
}
